function copyMarketingTiles() {
  let source = document.getElementById("marketing-tiles");
  if (!source?.children?.length) return;

  let dest = document.createElement("div");
  let clone = source.cloneNode(true); // true -> deep cloning, i.e. the whole subtree
  let copy = dest.appendChild(clone);
  dest.remove();

  return copy;
}

function injectMarketingTiles(tiles) {
  if (!tiles) return;
  let products_on_page = document.getElementById("product-grid");
  if (!products_on_page?.children?.length) return;

  let sorted_marketing_tiles = [...tiles.children]
    .filter(
      (el) =>
        el.id && el.dataset.position <= products_on_page.children.length // filters valid elements
    )
    .sort((a, b) => (+a.dataset.position < +b.dataset.position ? -1 : 1)); //marketing tiles should come sorted to be inserted correctly
  sorted_marketing_tiles.forEach((shop_tile, ix) => {
    let shop_tile_position = shop_tile.dataset.position || ix + 1;
    if (shop_tile_position <= 0) {
      shop_tile_position = 1;
    } // prevents user from inserting tiles in a position lower than the first element (1)
    shop_tile.setAttribute("injected", "");
    products_on_page.children[shop_tile_position - 1].insertAdjacentElement(
      "beforebegin",
      shop_tile
    );
  });
}

/* this only runs when using the design mode on shopify */
function shopifyDesignModeMarketingTilesLoad() {
  //this is to improve site's manager user experience when editing Marketing Tiles */
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      cleanInjectedTiles();
      initialMarketingTilesLoad();
      copyAndInjectTiles();
    });
  }

  function cleanInjectedTiles() {
    const injectedMarketingTiles = document.querySelectorAll("[injected]");
    for (let tile of injectedMarketingTiles) {
      tile.remove();
    }
  }
}

function initialTilesLoad() {
  let copy;
  return (shouldBuildMarketingTiles = false) => {
    if (copy && !shouldBuildMarketingTiles) {
      injectMarketingTiles(copy);
      return;
    }
    copy = copyMarketingTiles();
    injectMarketingTiles(copy);
  };
}

const initialMarketingTilesLoad = initialTilesLoad();

const loadMoreButtonInjectTiles = initialMarketingTilesLoad;

function copyAndInjectTiles() { return initialMarketingTilesLoad(true) };

initialMarketingTilesLoad(); // on mount injection

// this only runs when using the design mode on shopify
shopifyDesignModeMarketingTilesLoad();
